import React, {ReactElement, useEffect, useRef, useState} from "react";
import {
    Breakpoint,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Modal,
    styled,
    Typography

} from "@mui/material";
import ReactDOM from "react-dom";
import {WithWidthProps} from "@mui/material/Hidden/withWidth";

type ModalWindowProps = {
    isOpen:boolean,
    onClose:()=>void,
    header:ReactElement|string,
    actions:ReactElement,
    children:ReactElement,
    maxWidth?: Breakpoint,
    className?:string
}

const RootEl =styled('div')(({ theme }) => ({
    height: 300,
    flexGrow: 1,
    minWidth: 300,
    transform: 'translateZ(0)',
    // The position fixed scoping doesn't work in IE 11.
    // Disable this demo to preserve the others.
    '@media all and (-ms-high-contrast: none)': {
        display: 'none',
    }
}));



export function ModalWindow(props:ModalWindowProps): React.ReactElement|null {
    const elRef = useRef(null);
    if (!elRef.current) {
        elRef.current = document.createElement("div");
    }
    useEffect(() => {
        document.body.appendChild(elRef.current);
        return () => document.body.removeChild(elRef.current);
    }, []);
    const content =
        <RootEl>
    <Dialog open={props.isOpen}  onClose={props.onClose}
    //display: 'flex',
    //padding: (theme)=>theme.spacing(1),
    //alignItems: 'center',
    //justifyContent: 'center',
    maxWidth={props.maxWidth}
            fullWidth={!!props.maxWidth}
            className={props.className??''}
           >
            <DialogTitle fontSize="large" gutterBottom={false}>{props.header}</DialogTitle>
            <DialogContent dividers={true} sx={{borderTop:'none'}}>
                {props.children}
            </DialogContent>
            <DialogActions>
                {props.actions}
            </DialogActions>
    </Dialog>
        </RootEl>;
    return ReactDOM.createPortal(
        content,
        elRef.current
    );
}